module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/z-logo-animated-2b2489c5a514c9bb64aed6b8eb6b2139.gif";